export const SITE = {
  name: "WebStation",
  since: 2020,
  whatsappDisplay: "(11) 97448-9877",
  whatsappNumber: "5511974489877",
  email: "webstationbr@gmail.com",
  instagramHandle: "webstation.br",
  tiktokHandle: "webstation.br",
  instagram: "https://www.instagram.com/webstation.br/",
  tiktok: "https://www.tiktok.com/@webstation.br",
  defaultMessage:
    "Olá! Conheci a WebStation pelo site e gostaria de solicitar um orçamento para um projeto.",
};

export const waLink = (message = SITE.defaultMessage) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const NAV = [
  { id: "inicio", label: "Início" },
  { id: "servicos", label: "Serviços" },
  { id: "para-quem", label: "Para quem criamos" },
  { id: "processo", label: "Processo" },
  { id: "portfolio", label: "Portfólio" },
  { id: "faq", label: "FAQ" },
  { id: "contato", label: "Contato" },
];

export const PROJECT_TYPES = [
  "Site",
  "Landing Page",
  "Loja Virtual",
  "Aplicativo",
  "Sistema",
  "Solução personalizada",
  "Outro",
];

export const EASE = [0.22, 1, 0.36, 1];
